import { render, staticRenderFns } from "./CourseMaterialComponent.vue?vue&type=template&id=a3ed393e&"
import script from "./CourseMaterialComponent.vue?vue&type=script&lang=js&"
export * from "./CourseMaterialComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports